/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type Colors_QueryVariables = {||};
export type Colors_QueryResponse = {|
  +colors: ?{|
    +nodes: $ReadOnlyArray<{|
      +color: string,
      +id: string,
      +createdAt: string,
      +updatedAt: string,
      +dogs: {|
        +totalCount: number
      |},
    |}>
  |},
  +uncolored: ?{|
    +totalCount: number
  |},
|};
export type Colors_Query = {|
  variables: Colors_QueryVariables,
  response: Colors_QueryResponse,
|};
*/


/*
query Colors_Query {
  colors(orderBy: COLOR_ASC) {
    nodes {
      color
      id
      createdAt
      updatedAt
      dogs {
        totalCount
      }
    }
  }
  uncolored: dogs(condition: {colorId: null}) {
    totalCount
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "orderBy",
        "value": "COLOR_ASC"
      }
    ],
    "concreteType": "ColorsConnection",
    "kind": "LinkedField",
    "name": "colors",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Color",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "color",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "DogsConnection",
            "kind": "LinkedField",
            "name": "dogs",
            "plural": false,
            "selections": (v0/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": "colors(orderBy:\"COLOR_ASC\")"
  },
  {
    "alias": "uncolored",
    "args": [
      {
        "kind": "Literal",
        "name": "condition",
        "value": {
          "colorId": null
        }
      }
    ],
    "concreteType": "DogsConnection",
    "kind": "LinkedField",
    "name": "dogs",
    "plural": false,
    "selections": (v0/*: any*/),
    "storageKey": "dogs(condition:{\"colorId\":null})"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Colors_Query",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Colors_Query",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "76e6446547f7db12c0fb7d8c663d4c2a",
    "id": null,
    "metadata": {},
    "name": "Colors_Query",
    "operationKind": "query",
    "text": "query Colors_Query {\n  colors(orderBy: COLOR_ASC) {\n    nodes {\n      color\n      id\n      createdAt\n      updatedAt\n      dogs {\n        totalCount\n      }\n    }\n  }\n  uncolored: dogs(condition: {colorId: null}) {\n    totalCount\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'db43f1396190fb52ee68e2642478ab0b';

module.exports = node;
